import * as requests from 'api/requests';

import {
    addingInfoItem,
    addingInfoItemFailure,
    addingInfoItemSuccess,
    addingLink,
    addingLinkFailure,
    addingLinkSuccess,
    creatingDashboard,
    creatingDashboardFailure,
    creatingDashboardSuccess,
    deletingDashboard,
    deletingDashboardFailure,
    deletingDashboardPhoto,
    deletingDashboardPhotoFailure,
    deletingDashboardPhotoSuccess,
    deletingDashboardSuccess,
    deletingDashboards,
    deletingDashboardsFailure,
    deletingDashboardsSuccess,
    deletingInfoItem,
    deletingInfoItemFailure,
    deletingInfoItemSuccess,
    deletingLink,
    deletingLinkFailure,
    deletingLinkSuccess,
    deletingLinks,
    deletingLinksFailure,
    deletingLinksSuccess,
    editingLink,
    editingLinkFailure,
    editingLinkSuccess,
    gettingDashboard,
    gettingDashboardFailure,
    gettingDashboardSuccess,
    gettingDashboardsBySite,
    gettingDashboardsBySiteFailure,
    gettingDashboardsBySiteSuccess,
    gettingLink,
    gettingLinkFailure,
    gettingLinkSuccess,
    gettingMyDashboards,
    gettingMyDashboardsFailure,
    gettingMyDashboardsSuccess,
    gettingUrl,
    gettingUrlFailure,
    gettingUrlSuccess,
    sendingLinkHit,
    sendingLinkHitFailure,
    sendingLinkHitSuccess,
    udpatingInfoItemSuccess,
    updatingDashboard,
    updatingDashboardFailure,
    updatingDashboardLinks,
    updatingDashboardLinksFailure,
    updatingDashboardLinksSuccess,
    updatingDashboardSuccess,
    updatingDashboards,
    updatingDashboardsFailure,
    updatingDashboardsSuccess,
    sendingDashboardHit,
    sendingDashboardHitSuccess,
    sendingDashboardHitFailure,
    updatingInfoItem,
    updatingInfoItemFailure,
    uploadingDashboardPhoto,
    uploadingDashboardPhotoFailure,
    uploadingDashboardPhotoSuccess
} from 'redux/actions/dashboard';

import { displayErrorSwal } from 'utilities/Validations';
import { getUserFavorites } from './user';

export function createDashboard(newDashboard) {
    return (dispatch) => {
        dispatch(creatingDashboard());

        return requests
            .createDashboard(newDashboard)
            .then((dashboard) => {
                dispatch(creatingDashboardSuccess(dashboard));
            })
            .catch((error) => {
                let apiError = '';
                if (error.response && error.response.data) {
                    apiError = error.response.data;
                }
                displayErrorSwal(apiError || 'An error occurred trying to create this dashboard, please try again later.');
                dispatch(creatingDashboardFailure(error));
            });
    };
}

export function getDashboardsBySite(siteId, email = '') {
    return (dispatch) => {
        dispatch(gettingDashboardsBySite());

        return requests
            .getDashboardsBySite(siteId, email)
            .then((data) => {
                dispatch(gettingDashboardsBySiteSuccess(data));
            })
            .catch((error) => {
                displayErrorSwal('An error occurred getting this sites dashboards, please try again later.');
                dispatch(gettingDashboardsBySiteFailure(error));
            });
    };
}

export function deleteDashboard(dashboard) {
    return (dispatch) => {
        dispatch(deletingDashboard());

        return requests
            .deleteDashboard(dashboard)
            .then(() => {
                dispatch(getUserFavorites());
                dispatch(deletingDashboardSuccess(dashboard));
            })
            .catch((error) => {
                displayErrorSwal('An error occurred deleting this dashboard, please try again later.');
                dispatch(deletingDashboardFailure(error));
            });
    };
}

export function updateDashboard(dashboard) {
    return (dispatch) => {
        dispatch(updatingDashboard(dashboard));

        return requests
            .updateDashboard(dashboard)
            .then((data) => {
                dispatch(updatingDashboardSuccess(dashboard));
            })
            .catch((error) => {
                displayErrorSwal('An error occurred updating dashboard, please try again later.');
                dispatch(updatingDashboardFailure(error));
            });
    };
}

export function updateDashboards(dashboards) {
    return (dispatch) => {
        dispatch(updatingDashboards(dashboards));

        return requests
            .updateDashboards(dashboards)
            .then((data) => {
                dispatch(updatingDashboardsSuccess());
            })
            .catch((error) => {
                displayErrorSwal('An error occurred updating these dashboards, please try again later.');
                dispatch(updatingDashboardsFailure(error));
            });
    };
}

export function updateDashboardLinks(links) {
    return (dispatch) => {
        dispatch(updatingDashboardLinks(links));

        return requests
            .updateDashboardLinks(links)
            .then((data) => {
                dispatch(updatingDashboardLinksSuccess());
            })
            .catch((error) => {
                displayErrorSwal('An error occurred updating this dashboards links, please try again later.');
                dispatch(updatingDashboardLinksFailure(error));
            });
    };
}

export function addInfoItem(newInfoItem) {
    return (dispatch) => {
        dispatch(addingInfoItem());

        return requests
            .addInfoItem(newInfoItem)
            .then((data) => {
                dispatch(addingInfoItemSuccess(data.info));
            })
            .catch((error) => {
                displayErrorSwal('An error occurred ading this info item, please try again later.');
                dispatch(addingInfoItemFailure(error));
            });
    };
}

export function updateInfoItem(updatedInfoItem) {
    return (dispatch) => {
        dispatch(updatingInfoItem());

        return requests
            .updateInfoItem(updatedInfoItem)
            .then((data) => {
                dispatch(udpatingInfoItemSuccess(updatedInfoItem));
            })
            .catch((error) => {
                displayErrorSwal('An error occurred updating this info item, please try again later.');
                dispatch(updatingInfoItemFailure(error));
            });
    };
}

export function deleteInfoItem(infoItem) {
    return (dispatch) => {
        dispatch(deletingInfoItem());

        return requests
            .deleteInfoItem(infoItem)
            .then((data) => {
                dispatch(deletingInfoItemSuccess(infoItem));
            })
            .catch((error) => {
                displayErrorSwal('An error occurred deleting this info item, please try again later.');
                dispatch(deletingInfoItemFailure(error));
            });
    };
}

export function getDashboard(siteId, dashboardId) {
    return (dispatch) => {
        dispatch(gettingDashboard());

        return requests
            .getDashboard(siteId, dashboardId)
            .then((dashboard) => {
                dispatch(gettingDashboardSuccess(dashboard));
            })
            .catch((error) => {
                let apiError = '';
                if (error.response && error.response.data) {
                    apiError = error.response.data;
                }

                displayErrorSwal(apiError || 'An error occurred getting this dashboard, please try again later.');
                dispatch(gettingDashboardFailure(error));
            });
    };
}

export function getDashboardRestricted(siteId, dashboardId) {
    return (dispatch) => {
        dispatch(gettingDashboard());

        return requests
            .getDashboardRestricted(siteId, dashboardId)
            .then((dashboard) => {
                dispatch(gettingDashboardSuccess(dashboard));
            })
            .catch((error) => {
                let apiError = '';
                if (error.response && error.response.data) {
                    apiError = error.response.data;
                }

                displayErrorSwal(apiError || 'An error occurred getting this dashboard, please try again later.');
                dispatch(gettingDashboardFailure(error));
            });
    };
}

export function addLink(link) {
    return (dispatch) => {
        dispatch(addingLink());

        return requests
            .addLink(link)
            .then(() => {
                dispatch(addingLinkSuccess(link));
            })
            .catch((error) => {
                displayErrorSwal('An error occurred adding this link to the dashboard, please try again later.');
                dispatch(addingLinkFailure(error));
            });
    };
}

export function getLink(siteId, dashboardId, linkId) {
    return (dispatch) => {
        dispatch(gettingLink());

        return requests
            .getLink(siteId, dashboardId, linkId)
            .then((link) => {
                dispatch(gettingLinkSuccess(link));
            })
            .catch((error) => {
                displayErrorSwal('An error occurred getting this link, please try again later.');
                dispatch(gettingLinkFailure(error));
            });
    };
}

export function getUrl(siteId, dashboardId, linkId) {
    return (dispatch) => {
        dispatch(gettingUrl());

        return requests
            .getUrl(siteId, dashboardId, linkId)
            .then((link) => {
                dispatch(gettingUrlSuccess(link));
            })
            .catch((error) => {
                displayErrorSwal('An error occurred getting this url, please try again later.');
                dispatch(gettingUrlFailure(error));
            });
    };
}

export function editLink(updatedLink) {
    return (dispatch) => {
        dispatch(editingLink());

        return requests
            .editLink(updatedLink)
            .then((data) => {
                dispatch(editingLinkSuccess(updatedLink));
            })
            .catch((error) => {
                displayErrorSwal('An error occurred editing this link, please try again later.');
                dispatch(editingLinkFailure(error));
            });
    };
}

export function deleteLink(siteId, dashboardId, linkId) {
    return (dispatch) => {
        dispatch(deletingLink());

        return requests
            .deleteLink(siteId, dashboardId, linkId)
            .then((data) => {
                dispatch(deletingLinkSuccess(linkId));
            })
            .catch((error) => {
                displayErrorSwal('An error occurred deleting this link, please try again later.');
                dispatch(deletingLinkFailure(error));
            });
    };
}

export function sendLinkHit(siteId, dashboardId, linkId) {
    return (dispatch) => {
        dispatch(sendingLinkHit());

        return requests
            .sendLinkHit(siteId, dashboardId, linkId)
            .then((data) => {
                dispatch(sendingLinkHitSuccess());
            })
            .catch((error) => {
                dispatch(sendingLinkHitFailure(error));
            });
    };
}

export function deleteLinks(links) {
    return (dispatch) => {
        dispatch(deletingLinks());

        return requests
            .deleteLinks(links)
            .then((data) => {
                dispatch(deletingLinksSuccess(links));
            })
            .catch((error) => {
                displayErrorSwal('An error occurred deleting these links, please try again later.');
                dispatch(deletingLinksFailure(error));
            });
    };
}

export function deleteDashboards(dashboards) {
    return (dispatch) => {
        dispatch(deletingDashboards());

        return requests
            .deleteDashboards(dashboards)
            .then((data) => {
                dispatch(deletingDashboardsSuccess(dashboards));
            })
            .catch((error) => {
                displayErrorSwal('An error occurred deleting these dashboards, please try again later.');
                dispatch(deletingDashboardsFailure(error));
            });
    };
}

export function getMyDashboards() {
    return (dispatch) => {
        dispatch(gettingMyDashboards());

        return requests
            .getMyDashboards()
            .then((dashboards) => {
                dispatch(gettingMyDashboardsSuccess(dashboards));
            })
            .catch((error) => {
                displayErrorSwal('An error occurred getting your dashboards, please try again later.');
                dispatch(gettingMyDashboardsFailure(error));
            });
    };
}

export function uploadDashboardPhoto(siteId, dashboardId, photo) {
    return (dispatch) => {
        dispatch(uploadingDashboardPhoto());

        return requests
            .uploadDashboardPhoto(siteId, dashboardId, photo)
            .then((dashboard) => {
                dispatch(uploadingDashboardPhotoSuccess(dashboard));
            })
            .catch((error) => {
                displayErrorSwal('An error occurred uploading this dashboard image, please try again later.');
                dispatch(uploadingDashboardPhotoFailure(error));
            });
    };
}

export function deleteDashboardPhoto(siteId, dashboardId) {
    return (dispatch) => {
        dispatch(deletingDashboardPhoto());

        return requests
            .deleteDashboardPhoto(siteId, dashboardId)
            .then((dashboard) => {
                dispatch(deletingDashboardPhotoSuccess(dashboard));
            })
            .catch((error) => {
                displayErrorSwal('An error occurred deleting this dashboard image, please try again later.');
                dispatch(deletingDashboardPhotoFailure(error));
            });
    };
}

export function sendDashboardHit({
    siteId,
    dashboardId,
    history
}) {
    return (dispatch) => {
        dispatch(sendingDashboardHit());

        return requests.sendDashboardHit(siteId, dashboardId)
            .then(() => {
                dispatch(getMyDashboards());
                dispatch(getUserFavorites());
                history.push(`/site/${siteId}/dashboard/${dashboardId}`);
                dispatch(sendingDashboardHitSuccess());
            })
            .catch((error) => {
                dispatch(sendingDashboardHitFailure(error));
            });
    };
}